<template>
    <DModal
        :show="showModal"
        :title="title"
        is-confirm
        is-medium
        @close="closeModal()"
        @confirm="save"
    >
        <DCard
            class="card-height"
            padding
        >
            <DRow>
                <DCol
                    sm="3"
                    class="mt-2"
                >
                    <span class="required">
                        <strong>
                            {{ label }}
                        </strong>
                    </span>
                </DCol>
                <DCol sm="9">
                    <DMultiSelect
                        id="list"
                        :options="items"
                        :search="true"
                        :selection="true"
                        :search-placeholder="label"
                        selection-type="text"
                        @update="updateItems"
                    />
                </DCol>
            </DRow>
        </DCard>
    </DModal>
</template>

<script setup>

import { route } from '~@/Composables/route'
import { onMounted, ref } from 'vue'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    incident: {
        type: String,
        default: null
    },
    section: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    }
})

const items = ref([])

onMounted(() => {
    if (props.section === 'contracts') {
        window.axios.get(route('customers.customers.fetch-business-incident-contracts', {
            customer: props.incident.customer_id,
            businessIncident: props.incident.id
        }))
            .then(response => {
                items.value = response.data.items
            })
    }

    if (props.section === 'invoices') {
        window.axios.get(route('customers.customers.fetch-business-incident-invoices', {
            customer: props.incident.customer_id,
            businessIncident: props.incident.id
        }))
            .then(response => {
                items.value = response.data.items
            })
    }

    if (props.section === 'orders') {
        window.axios.get(route('customers.customers.fetch-business-incident-orders', {
            customer: props.incident.customer_id,
            businessIncident: props.incident.id
        }))
            .then(response => {
                items.value = response.data.items
            })
    }

    if (props.section === 'tickets') {
        window.axios.get(route('customers.customers.fetch-business-incident-tickets', {
            customer: props.incident.customer_id,
            businessIncident: props.incident.id
        }))
            .then(response => {
                items.value = response.data.items
            })
    }
})

const form = useForm({
    items: []
})

function updateItems (values) {
    form.items = values
}

const emit = defineEmits(['close-modal', 'confirm-modal'])

const closeModal = () => {
    emit('close-modal')
}

function save () {
    emit('confirm-modal', form)
}

</script>

<style lang="scss">
.card-height {
    min-height: 400px;
}
</style>
